import * as angular from "angular";
import * as _ from "lodash";
import {IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";

export class OrderRequestsService {

  /* @ngInject */
  constructor(private $log, private $q: IQService, private $order, private OrdersAPI, private splitService: SplitService) {
  }

  // ******************************
  // External methods
  // ******************************

  getOldQuote(_services, _accountId, _pricePlanType) {

    if (_.isUndefined(_services) || _.isUndefined(_accountId) || _.isUndefined(_pricePlanType)) {
      return this.$q.reject('One (or more) of the required parameters resolved to undefined, the parameters are as ' +
        'follows : Services (Array), Account ID (String), Price Plan ID (String). \n ' +
        '-->orderRequestsService@getOrderQuote');
    }

    const payload = {
      accountId: _accountId,
      pricePlanType: _pricePlanType,
      services: _services
    };

    return this.$$call(this.OrdersAPI.actions.quoteOld, {}, payload, {});
  }

  getOrderQuote(_services, _accountId, _pricePlanType, _from, _to) {

    if (_.isUndefined(_services) || _.isUndefined(_accountId) || _.isUndefined(_pricePlanType)) {
      return this.$q.reject('One (or more) of the required parameters resolved to undefined, the parameters are as ' +
        'follows : Services (Array), Account ID (String), Price Plan ID (String). \n ' +
        '-->orderRequestsService@getOrderQuote');
    }

    const payload = {
      accountId: _accountId,
      pricePlanType: _pricePlanType,
      services: _services
    };

    return this.$$call(this.OrdersAPI.actions.quote,
      {
        from: _from,
        to: _to,
        timeWindowGapDays: 0,
        zoneId: this.splitService.getTimeZone()
      }, payload, {});
  }

  getOrderSettings(accountId, serviceType, programType, quoteTypes?, programId?, timeWindowGapDays?, from?, zoneId?: string) {
    const api = this.OrdersAPI.actions.settings;
    return this.$$call(api,
      {
        accountId: accountId,
        serviceType: serviceType,
        programType: programType,
        programId: programId,
        type: quoteTypes,
        timeWindowGapDays: !from ? (timeWindowGapDays || 0) : undefined,
        from: from,
        zoneId: zoneId || this.splitService.getTimeZone()
      }, {}, {});
  }

  getOrderPrice(_order, _accountId) {

    if (_.isUndefined(_order) || _.isUndefined(_accountId)) {
      return this.$q.reject('One (or more) of the required parameters resolved to undefined, the parameters are as ' +
        'follows : Order (Object), Account ID (String). \n ' +
        '-->orderRequestsService@getOrderPrice');
    }

    return this.$$call(this.OrdersAPI.actions.price, {accountId: _accountId}, _order, {});
  }


  placeOrder(_order?, _accountId?, isShouldSendSms?) {
    if (_.isUndefined(_order) || _.isUndefined(_accountId)) {
      return this.$q.reject('One (or more) of the required parameters resolved to undefined, the parameters are as ' +
        'follows : Order (Object), Account ID (String). \n ' +
        '-->orderRequestsService@placeOrder');
    }
    // this.deliveryRef.$update(delivery, {}, {sendSms: isShouldSendSms})
    return this.$order().$put(_order, {
      accountId: _accountId, sendSms: isShouldSendSms
    });
    // sendSms: isShouldSendSms
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$order().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.orders')
  .service('orderRequestsService', OrderRequestsService);
